import iconLogo from '../images/logo.svg';
import iconLogoDark from '../images/logo-dark.svg';
import iconLogoFooter from '../images/f-logo.svg';

import iconToggle from '../images/toggle.svg';
import iconClose from '../images/close.svg';

import iconSearch from '../images/search.svg';

//import iconDoc from '../images/icon-1.svg';
import iconBox from '../images/icon-2.svg';
import iconScales from '../images/icon-3.svg';
//import iconComp from '../images/icon-4.svg';

import iconLock from '../images/icon-lock.svg';
import iconCase from '../images/icon-case.svg';
import iconHammer from '../images/icon-hammer.svg';
import iconCalc from '../images/icon-calc.svg';
import iconCrystal from '../images/icon-crystal.svg';
import iconComp from '../images/icon-comp.svg';
import iconLoupe from '../images/icon-loupe.svg';
import iconRub from '../images/icon-rub.svg';
import iconDoc from '../images/icon-doc.svg';
import iconMegaphone from '../images/icon-megaphone.svg';
import iconChart from '../images/icon-chart.svg';
import iconDocPeople from '../images/icon-doc-people.svg';
import iconDiagram from '../images/icon-diagram.svg';
import iconPeople from '../images/icon-people.svg';
import iconI from '../images/icon-i.svg';
import iconPuzzle from '../images/icon-puzzle.svg';
import iconSecure from '../images/icon-secure.svg';
import iconOpenCase from '../images/icon-open-case.svg';
import iconDocum from '../images/icon-docum.svg';
import iconLocate from '../images/icon-locate.svg';
import iconMan from '../images/icon-man.svg';
import iconMap from '../images/icon-map.svg';
import iconPhone from '../images/icon-phone.svg';
import iconTablet from '../images/icon-tablet.svg';
import iconLaptop from '../images/icon-laptop.svg';
import iconSmartphone from '../images/icon-smartphone.svg';

// import jQuery from 'jquery';
import * as Popper from "@popperjs/core"
import Modal from 'bootstrap'
import * as bootstrap from 'bootstrap'

require("./forms-validation.js");

import Inputmask from "inputmask";

import styleSelect from "./styleselect.js";

import {settings} from './variables.js';

var baseUrl = settings.apiBaseUrl;

const navbarHeader = document.getElementById('navbarToggler')
const headerElements = document.getElementsByClassName("header")

navbarHeader.addEventListener('show.bs.collapse', event => {
  
   if (headerElements.length > 0) {
    headerElements[0].classList.add("header--collapsed")
   }
    
})

navbarHeader.addEventListener('hide.bs.collapse', event => {
  
    if (headerElements.length > 0) {
        headerElements[0].classList.remove("header--collapsed")
    }

    var dropdownBlocks = document.querySelectorAll(".dropdown-menu")
    Array.prototype.slice.call(dropdownBlocks).forEach(function (dropdownBlock) {
        dropdownBlock.classList.remove("hide-menu")
        dropdownBlock.classList.remove("show")
    })
    
})

Inputmask({
    mask: "*9 (999) 999-99-99",
    placeholder: "X",
    colorMask: true,
    definitions: {
        '*': {
            validator: "[+]{1,1}"
        }
    }
}).mask(document.querySelectorAll('input[type="tel"]'));

Inputmask({
    mask: "99.99.9999",
    placeholder: "_",
    colorMask: true,
    clearMaskOnLostFocus: false
}).mask(document.querySelectorAll('input.date-mask'));

Inputmask({
    mask: "9999999999999",
    placeholder: "XXXXXXXXXXXXX",
    colorMask: true,
    clearMaskOnLostFocus: false
}).mask(document.querySelectorAll('input.ogrn-field'));

var inputs_masked = document.querySelectorAll('input[type="tel"]')

Array.prototype.slice.call(inputs_masked)
    .forEach(function (input_item) {
        Inputmask.setValue(input_item, "+7");

        input_item.addEventListener('input', function (event) {
            var controled = input_item.value.replaceAll('X', '').replaceAll('-', '').replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '')
            if (controled.length < 2) {
                Inputmask.setValue(input_item, "+7");
            }
        })
    })


document.addEventListener("DOMContentLoaded", (event) => {
    allowedHoverControll()
    marginControl()
    allowAccordionsOpen()
    openAccordionByHash()
    searchFormInit()
    formSwitchStates()
    rendreInputFileFields()
    addStylizedSelects()
    navigateToTab()
});

window.addEventListener("resize", (event) => {
    marginControl()
});

window.addEventListener("scroll", (event) => {
    openAccordionByHash()
});

var allowOpenAccordions = true

const allowAccordionsOpen = function () {
    var accordionsControls = document.getElementsByClassName("scroll-accordion")
    Array.prototype.slice.call(accordionsControls).forEach(function (scrollBtn) {
        scrollBtn.addEventListener('click', event => {
            allowOpenAccordions = true
        })
    })
}

const openAccordionByHash = function () {
    var hashUrl = window.location.hash
    if (hashUrl) {
        var accordionBtn = document.getElementById(hashUrl.replaceAll("#", ""))
        if (accordionBtn && allowOpenAccordions) {
            allowOpenAccordions = false
            var accordionBlockId = accordionBtn.getAttribute("aria-controls")
            if (accordionBlockId) {
                var accordionBlock = document.getElementById(accordionBlockId)
                if (accordionBlock && !accordionBlock.classList.contains("show")) {
                    var bsCollapse = new bootstrap.Collapse(accordionBlock, {
                        toggle: true
                    })
                    accordionBlock.addEventListener('shown.bs.collapse', function () {
                        accordionBtn.scrollIntoView()
                    })
                }

            }
        }
    }
}

var controlHoverMute = true

const allowedHoverControll = function () {
    var dropdownMenuBlocks = document.querySelectorAll('.dropdown')
    Array.prototype.slice.call(dropdownMenuBlocks).forEach(function (dropdownMenu) {
        var itsHovered = dropdownMenu.matches(':hover')
        if ((controlHoverMute && !itsHovered) || !controlHoverMute) {
            dropdownMenu.classList.add("allowed-hover")
        }

        dropdownMenu.addEventListener('mouseover', event => {
            if (controlHoverMute) {
                controlHoverMute = false
                allowedHoverControll()
            }

        })
    })
}

const drpdownMenus = document.querySelectorAll('.dropdown')

Array.prototype.slice.call(drpdownMenus).forEach(function (dropdownMenu) {

    var dropdownBlocks = dropdownMenu.querySelectorAll(".dropdown-menu")

    dropdownMenu.addEventListener('show.bs.dropdown', event => {
        
        Array.prototype.slice.call(dropdownBlocks).forEach(function (dropdownBlock) {
            dropdownBlock.classList.remove("hide-menu")
        })
    })
    dropdownMenu.addEventListener('hidden.bs.dropdown', event => {
        Array.prototype.slice.call(dropdownBlocks).forEach(function (dropdownBlock) {
            dropdownBlock.classList.add("hide-menu")
        })
    })
})

const marginControl = function () {
    var window_width = window.screen.width

    var blocksForRender = document.getElementsByClassName("render-margin")

    var containers = document.getElementsByClassName("container")

    var containerWidth = containers[0].clientWidth

    Array.prototype.slice.call(blocksForRender).forEach(function (render_block) {

        if (window_width < 1280) {
            
            var block_margin = calcScrollMargin(containerWidth)
            render_block.style['margin-right'] = '-' + block_margin + 'px'

            render_block.addEventListener('scroll', event => {
                var scrolled = render_block.scrollLeft
                if (scrolled > 0) {
                    render_block.style['margin-left'] = '-' + block_margin + 'px'
                }
                else {
                    render_block.style['margin-left'] = 'auto'
                }
            })

        }
        else {
            render_block.style['margin-right'] = ''
            render_block.style['margin-left'] = ''
        }
        
    })

}

const calcScrollMargin = function (containerWidth) {
    var window_width = window.screen.width
    var margin = 8

    if (window_width < 768) {
        margin = 16
    }
    var block_margin = (window_width - containerWidth) / 2 + margin
    return block_margin
}



const cityAccordion = document.getElementById("accordionCity")

if (cityAccordion) {
    var accordion_blocks = cityAccordion.querySelectorAll(".accordion-item")
} else {
    var accordion_blocks = []
}


Array.prototype.slice.call(accordion_blocks).forEach(function (accordion) {
    accordion.addEventListener('show.bs.collapse', event => {

        var dataSourceElement = event.target.parentElement

        try {
            var mapCenter = dataSourceElement.dataset.mapCenter.split(",")
            var labelTitle = dataSourceElement.dataset.labelTitle
            var labelCoordinates = dataSourceElement.dataset.labelCoordinates.split("/")

            var resultCoordinates = []
            labelCoordinates.forEach(function (item) {
                resultCoordinates.push(
                    {
                        title: labelTitle,
                        coordinates: item.split(",")
                    }
                )
            })

            generate_map("accordionMap", mapCenter, resultCoordinates)
        } catch (error) {
            console.log(error)
        }
        
    })
})

window.mapFromUrl = function () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    var mapCenterText = urlParams.get("map_center", null)

    var mapCenter = null
    var coordinates = null
    var label = "ВТБ Регистратор"

    if (mapCenterText) {
        mapCenter = mapCenterText.split(",")
    }

    var coordinatesText = urlParams.get("coordinates", null)
    if (coordinatesText) {
        coordinates = coordinatesText.split(",")
    }

    var labelText = urlParams.get("label", null)
    if (labelText) {
        label = labelText
    }

    if (mapCenter && coordinates && label) {
        var placemark = {
            title: label,
            coordinates: coordinates
        }
        generate_map("accordionMap", mapCenter, [placemark])
    }
}

var accordionMapElement = document.getElementById("accordionMap")
var accordionMap, accordionPlacemark;

window.generate_map = function (selector_block, center, placemarks){

    // ymaps.ready(init);

    if (accordionMap) {
        accordionMap.destroy()
    }

    accordionMap = new ymaps.Map(accordionMapElement, {
        center: center,
        zoom: 12,
        width: '100%'
    });
    placemarks.forEach(function(entry) {
        accordionPlacemark = new ymaps.Placemark(entry.coordinates, {
            hintContent: entry.title,
            balloonContent: entry.title
        });
        accordionMap.geoObjects.add(accordionPlacemark);

    });

}

try {
    ymaps.ready(mapInit)
} catch {}

function mapInit() {
    accordionMap = new ymaps.Map(accordionMapElement, {
        center: [55.755864, 37.617698],
        zoom: 5,
        width: '100%'
    })

    mapFromUrl()
}


window.searchFormInit = function () {
    var searchInputs = document.querySelectorAll('input[type="search"]')

    Array.prototype.slice.call(searchInputs).forEach(function (searchField) {
        var clearBtns = searchField.parentElement.querySelectorAll(".clear-search")

        Array.prototype.slice.call(clearBtns).forEach(function (clearBtn) {
            clearBtn.addEventListener('click', eventClear => {
                searchField.value = ""
                var inputEvent = new Event('input')
                searchField.dispatchEvent(inputEvent)
            })
        })

        searchField.addEventListener('input', event => {
            if (searchField.value.length > 0) {
                Array.prototype.slice.call(clearBtns).forEach(function (clearBtn) {
                    clearBtn.classList.add("d-block")
                })
            }
            else {
                Array.prototype.slice.call(clearBtns).forEach(function (clearBtn) {
                    clearBtn.classList.remove("d-block")
                })
            }
        })
    })
}


const jurModal = document.getElementById('jurModal')
if (jurModal) {

    const eventSelectItemInModel = new Event("change")

    jurModal.addEventListener('show.bs.modal', event => {
    
    const button = event.relatedTarget
    
    const recipient = button.getAttribute('data-bs-whatever')
    
    const modalSelect = document.getElementById("selectService")
    
    if (recipient) {
        modalSelect.value = recipient
        modalSelect.dispatchEvent(eventSelectItemInModel)
    }
  })
}


window.formSwitchStates = function() {

    const eventOnSwitch = new Event("change")

    function changeBlockState(switchInput, switchBlock) {
        if (switchInput.checked) {
            switchBlock.classList.remove("form-switch--off")
            switchBlock.classList.add("form-switch--on")
        }
        else {
            switchBlock.classList.remove("form-switch--on")
            switchBlock.classList.add("form-switch--off")
        }
    }

    let formSwitches = document.getElementsByClassName("form-switch")
    
    Array.prototype.slice.call(formSwitches).forEach(function (switchBlock) {

        var switchInputs = switchBlock.querySelectorAll("input.switch__input")

        if (switchInputs) {
            var switchInput = switchInputs[0]
            changeBlockState(switchInput, switchBlock)
            switchInput.addEventListener('change', eventClear => {
                changeBlockState(switchInput, switchBlock)
            })
        }

        switchBlock.addEventListener('click', eventSwitchClick => {
            if (switchInputs) {
                switchInputs[0].checked = !switchInputs[0].checked
                switchInputs[0].dispatchEvent(eventOnSwitch)
            }
        })
        
    })
}

window.rendreInputFileFields = function () {
    var fileFields = document.querySelectorAll("input[type='file']")

    const evenFileFieldChange = new Event("change")

    Array.prototype.slice.call(fileFields).forEach(fileField => {

        fileField.addEventListener('change', eventSelectFile => {
            let fileList = fileField.files

            let fileLabels = eventSelectFile.target.parentElement.getElementsByClassName("upload__text")
            let fileClears = eventSelectFile.target.parentElement.getElementsByClassName("upload__cancel")

            if (fileList && fileList.length > 0) {
                if (fileLabels) {
                    fileLabels[0].textContent = fileList[0].name
                }
                if (fileClears) {
                    fileClears[0].classList.remove("d-none")
                }
            }
            else {
                if (fileLabels) {
                    fileLabels[0].textContent = ""
                }
                if (fileClears) {
                    fileClears[0].classList.add("d-none")
                }
            }

            Array.prototype.slice.call(fileClears).forEach(clearItem => {
                clearItem.addEventListener('click', clearFileClick => {
                    eventSelectFile.target.value = ""
                    eventSelectFile.target.dispatchEvent(evenFileFieldChange)
                })
            })

        })
    })
}

window.navigateToTab = function () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    var tabId = urlParams.get("open_tab", null)

    if (tabId) {
        let selectTab = new bootstrap.Tab(`#${tabId}`)
        if (selectTab) {
            selectTab.show()
        }
    }
}

window.addStylizedSelects = function () {
    var selectsForStyling = document.querySelectorAll("select.select-style")
    var selectsStyles = {}
    Array.prototype.slice.call(selectsForStyling).forEach(selectItem => {
        styleSelect(selectItem)
    })
}